import { createFileRoute } from "@tanstack/react-router";
import { LogsPage, type LogsSearch } from "@/features/logs/page";

const text = (v: unknown) => (typeof v === "string" && v.trim() ? v.trim() : undefined);

export const Route = createFileRoute("/_app/logs")({
  validateSearch: (search: Record<string, unknown>): LogsSearch => ({
    signal: search.signal === "metrics" || search.signal === "traces" ? search.signal : undefined,
    q: text(search.q),
    name: text(search.name),
    route: search.route === "pass" || search.route === "drop" ? search.route : undefined,
    project: text(search.project),
  }),
  component: LogsPage,
});
